const ERROR_CODES = {
	'olo:menu': new Set([
		'SCHDNULL',
		'SCHDINV',
		'SCHDNOITM',
		'SCHDNA',
		'SCHDNONEAVAIL',
		'LONOFO',
		'ITMNF',
		'LONONA',
	]),
	'ooc:time-slots': new Set([
		'LONOFO',
		'STORINACT',
		'STORCLSD',
		'STRTZNTSET',
		'ORDSETGNF',
		'DINNTAVAIL',
		'TAKNTAVAIL',
		'DELNTAVAIL',
	]),
} as const satisfies Record<string, ReadonlySet<string>>

export type ApiNamespace = keyof typeof ERROR_CODES

export function toI18nKey(namespace: ApiNamespace, code: string): string {
	const segment = ERROR_CODES[namespace].has(code) ? code : 'generic'
	return `api:${namespace}:${segment}:error`
}
